import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ModalDialog } from 'shared/components/modals/ModalDialog';
import { createPhysicalDemandsTemplate, setCreatePhysicalDemandsTemplateModalState } from 'modules/settings/submodules/clients/physicalDemands/store/action';
import { selectIsCreatePhysicalDemandsTemplateModalOpened, selectIsPhysicalDemandsTemplateCreating } from 'modules/settings/submodules/clients/physicalDemands/store/selectors';
import TemplateFormWrapper
    from 'modules/settings/submodules/clients/components/PhysicalDemandsAndWorkingConditions/AddTemplate/Modal/TemplateFormWrapper';
import { ITemplateFormValues } from 'modules/settings/submodules/clients/components/PhysicalDemandsAndWorkingConditions/AddTemplate/Modal/models';
import { useColoredFormModalStyles } from 'shared/components/modals/ModalStyles';

export default function CreatePhysicalDemandsModal() {
    const dispatch = useDispatch();
    const classes = useColoredFormModalStyles();

    const isLoading = useSelector(selectIsPhysicalDemandsTemplateCreating);
    const onSave = useCallback((values: ITemplateFormValues) => {
        dispatch(createPhysicalDemandsTemplate.init(values));
    }, [dispatch]);
    const isOpen = useSelector(selectIsCreatePhysicalDemandsTemplateModalOpened);
    const onClose = useCallback(() => {
        dispatch(setCreatePhysicalDemandsTemplateModalState(false));
    }, [dispatch]);

    return (
        <ModalDialog
            title="Add New Physical Demand Template"
            isOpened={isOpen}
            onClose={onClose}
            modalProps={{
                customClasses: classes,
                showCloseIcon: true,
            }}
        >
            <TemplateFormWrapper
                submitTitle="Add template"
                onSubmit={onSave}
                templateLabel="Physical Demands"
                isLoading={isLoading}
                onCancel={onClose}
            />
        </ModalDialog>
    );
}
